import { render, staticRenderFns } from "./PqyTotStts.vue?vue&type=template&id=0f8a5d30&"
import script from "./PqyTotStts.vue?vue&type=script&lang=js&"
export * from "./PqyTotStts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports